import axios, { AxiosError } from "axios";

/** Whether an axios/restClient error is an intentional request cancellation. */
export const isRequestCancelled = (error: unknown): boolean => {
    if (!error || typeof error !== "object") {
        return false;
    }
    const err = error as AxiosError;
    return (
        axios.isCancel(err) ||
        err.code === "ERR_CANCELED" ||
        err.name === "CanceledError" ||
        err.name === "AbortError"
    );
};

export const getRetryDelay = (error: AxiosError) => {
    const delayInSeconds = error?.response?.headers["retry-after"];
    return Number(delayInSeconds || 0);
};
